import React, {forwardRef} from 'react'
import {Input} from 'antd'
import scaleCompressImage from 'lib/scaleCompressImage'

interface Props {
  value?: string
  onChange?: (data: string) => void
  accept?: string
}

const FileField = forwardRef<Input, Props>(({value, onChange, ...rest}, ref) => {
  async function handleFiles(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0]
    if (file) {
      const base64String = await scaleCompressImage(file)
      return onChange && onChange(base64String)
    }
  }

  return (
    <Input
      {...rest}
      ref={ref}
      type="file"
      onChange={handleFiles}
    />
  )
})

export default FileField
